import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["rioConfig", "headerDataSource"];
import React, { useEffect } from 'react';
import { breakpoints } from '@chegg-ui/theme';
import { updateAuthState, initializeRioClient } from '@chegg-me-components/utils';
import { ApolloProvider } from '@apollo/client';
import Media from 'react-media';
import HeaderShell from '../shared/HeaderShell';
import { configureHeaderGQLServer } from '../shared/configureHeaderGQLServer';
import DesktopHeaderContent from '../shared/desktop/DesktopHeaderContent';
import MobileHeaderContent from '../shared/mobile/MobileHeaderContent';
import useApolloClient from '../shared/useApolloClient';
import useHeaderData from '../shared/useHeaderData';
import { ResponsiveHeaderSearchContainer } from '../styles';
import { ExplicitlyHideSearchBar } from '../types';
export var HeaderPresentational = function HeaderPresentational(_ref) {
  var serverRenderAsMobile = _ref.serverRenderAsMobile,
      mainContentId = _ref.mainContentId,
      skipDataQuery = _ref.skipDataQuery,
      user = _ref.user,
      cartCount = _ref.cartCount,
      children = _ref.children,
      navType = _ref.navType,
      envUrl = _ref.envUrl,
      activeSubLink = _ref.activeSubLink,
      pageTrackId = _ref.pageTrackId,
      onClickSignIn = _ref.onClickSignIn,
      onClickSignUp = _ref.onClickSignUp,
      dataTest = _ref['data-test'],
      onClickSignOut = _ref.onClickSignOut,
      CSPOnboardingEnabled = _ref.CSPOnboardingEnabled,
      CSPOnboardingOptions = _ref.CSPOnboardingOptions,
      customCenterNavConfig = _ref.customCenterNavConfig;
  var isResponsiveHeaderSearch = children !== ExplicitlyHideSearchBar && !Object.keys(children.props).includes('serverRenderAsMobile');

  var _useHeaderData = useHeaderData(envUrl, user, cartCount, onClickSignOut, skipDataQuery, navType),
      userData = _useHeaderData.userData,
      signOutUser = _useHeaderData.signOutUser,
      userDataLoading = _useHeaderData.userDataLoading;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderShell, {
    isResponsiveSearch: isResponsiveHeaderSearch,
    mainContentId: mainContentId,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(Media, {
    query: {
      maxWidth: breakpoints.md.max
    },
    defaultMatches: !!serverRenderAsMobile
  }, function (matches) {
    return matches ? /*#__PURE__*/React.createElement(MobileHeaderContent, {
      navType: navType,
      user: user || (userData === null || userData === void 0 ? void 0 : userData.userProfile),
      envUrl: envUrl,
      cartCount: cartCount !== null && cartCount !== void 0 ? cartCount : userData === null || userData === void 0 ? void 0 : userData.cartCount,
      onClickSignOut: signOutUser,
      userDataLoading: userDataLoading,
      onClickSignIn: onClickSignIn,
      onClickSignUp: onClickSignUp,
      activeSubLink: activeSubLink,
      pageTrackId: pageTrackId
    }, children) : /*#__PURE__*/React.createElement(DesktopHeaderContent, {
      navType: navType,
      user: user || (userData === null || userData === void 0 ? void 0 : userData.userProfile),
      cartCount: cartCount !== null && cartCount !== void 0 ? cartCount : userData === null || userData === void 0 ? void 0 : userData.cartCount,
      onClickSignOut: signOutUser,
      onClickSignIn: onClickSignIn,
      onClickSignUp: onClickSignUp,
      mainContentId: mainContentId,
      userDataLoading: userDataLoading,
      CSPOnboardingEnabled: CSPOnboardingEnabled,
      CSPOnboardingOptions: CSPOnboardingOptions,
      customCenterNavConfig: customCenterNavConfig,
      envUrl: envUrl,
      pageTrackId: pageTrackId,
      activeSubLink: activeSubLink
    }, children);
  })),
  /* istanbul ignore next */
  isResponsiveHeaderSearch &&
  /*#__PURE__*/

  /* istanbul ignore next */
  React.createElement(ResponsiveHeaderSearchContainer, null, /*#__PURE__*/React.cloneElement(children, {
    pageLocation: children.props.pageLocation ? children.props.pageLocation : navType
  })));
};
HeaderPresentational.displayName = 'HeaderPresentational';

var Header = function Header(_ref2) {
  var rioConfig = _ref2.rioConfig,
      headerDataSource = _ref2.headerDataSource,
      passThoughProps = _objectWithoutProperties(_ref2, _excluded);

  useEffect(function () {
    /**
     * Initialize Rio Client
     */

    /* istanbul ignore next */
    if (rioConfig) {
      initializeRioClient(rioConfig);
    }
    /**
     * This function will update the rio-client
     * state if user is logged in
     */


    updateAuthState();
  }, []);

  var _useApolloClient = useApolloClient({
    headerDataSource: configureHeaderGQLServer(headerDataSource)
  }),
      client = _useApolloClient.client,
      existingClient = _useApolloClient.existingClient;
  /* istanbul ignore next */


  return existingClient ? /*#__PURE__*/React.createElement(HeaderPresentational, passThoughProps) : /*#__PURE__*/React.createElement(ApolloProvider, {
    client: client
  }, /*#__PURE__*/React.createElement(HeaderPresentational, passThoughProps));
};

Header.displayName = 'Header';
export default Header;